export const IDENTITY_VALIDATION_PAYMENT_ROUTE = '/profile/partner/my-products';
export const IDENTITY_VALIDATION_NETWORK_ROUTE =
	'/profile/ambassador/account-tree';

export const IDENTITY_VALIDATION_ALLOWED_ROUTES = [
	IDENTITY_VALIDATION_PAYMENT_ROUTE,
	IDENTITY_VALIDATION_NETWORK_ROUTE
] as const;

export function isIdentityValidationAllowedRoute(url: string): boolean {
	const currentPath = url.split(/[?#]/, 1)[0];

	return IDENTITY_VALIDATION_ALLOWED_ROUTES.some(
		(route) => currentPath === route || currentPath.startsWith(`${route}/`)
	);
}
